// Major City List

const cityList = [
    "Bangalore",
    "New York",
    "Tokyo",
    "London",
    "Paris",
    "Mumbai",
    "Shanghai",
    "Delhi",
    "São Paulo",
    "Mexico City",
    "Cairo",
    "Beijing",
    "Dhaka",
    "Karachi",
    "Lagos",
    "Istanbul",
    "Moscow",
    "Manila",
    "Bangkok",
    "Jakarta",
    "Tehran",
    "Kinshasa",
    "Guangzhou",
    "Tianjin",
    "Chongqing",
    "Shenzhen",
    "Wuhan",
    "Chennai",
    "Dongguan",
    "Foshan",
    "Nanjing",
    "Zhengzhou",
    "Riyadh",
    "Bogotá",
    "Lima",
    "Buenos Aires",
    "Johannesburg",
    "Los Angeles",
    "Chicago",
    "Ahmedabad",
    "Houston",
    "Phoenix",
    "Philadelphia",
    "San Antonio",
    "San Diego",
    "Dallas",
    "San Jose",
    "Austin",
    "Jacksonville",
    "Fort Worth",
    "Indianapolis",
    "Columbus",
    "Detroit",
    "Memphis",
    "El Paso",
    "Seattle",
    "Denver",
    "Las Vegas",
    "Portland",
    "Baltimore",
    "Oklahoma City",
    "Sacramento",
    "Kansas City",
    "Cincinnati",
    "Hyderabad",
    "Atlanta",
    "Boston",
    "San Francisco",
    "Miami",
    "Nashville",
    "Charlotte",
    "Houston",
    "Phoenix",
    "Philadelphia",
    "San Antonio",
    "San Diego",
    "Dallas",
    "San Jose",
    "Austin",
    "Jacksonville",
    "Fort Worth",
    "Indianapolis",
    "Columbus",
    "Detroit",
    "Memphis",
    "El Paso",
    "Seattle",
    "Lucknow",
    "Denver",
    "Las Vegas",
    "Portland",
    "Baltimore",
    "Oklahoma City",
    "Sacramento",
    "Kansas City",
    "Cincinnati",
    "Atlanta",
    "Boston",
    "San Francisco",
    "Miami",
    "Nashville",
    "Charlotte",
];

export default cityList.sort();